import React from 'react';
import './Rector.css';
import Navbar from '../../components/Homepage/Navbar/Navbar';
import Footer from '../../components/Homepage/Footer/Footer';
import { administrationData } from '../../data/administrationData';

const AcademicAffairs = () => {
  const academicAffairsData = administrationData.academicAffairs;
  
  return (
    <div className="rector-page">
      <Navbar />
      
      <div className="rector-container">
        <div className="page-header">
          <h1>{academicAffairsData.office}</h1>
          <div className="header-underline"></div>
        </div>
        
        <div className="rector-profile-section">
          <div className="rector-profile">
            <div className="profile-image">
              <img src={academicAffairsData.image} alt={academicAffairsData.alt} />
            </div>
            
            <div className="profile-details">
              <h2>{academicAffairsData.name}</h2>
              <p className="designation">{academicAffairsData.designation}</p>
              <p className="designation">{academicAffairsData.fullDesignation}</p>
              <p className="designation">{academicAffairsData.email}</p>
              <p className="designation">{academicAffairsData.phone}</p>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default AcademicAffairs;